import { render, staticRenderFns } from "./assistantChatTester.vue?vue&type=template&id=900db25c&scoped=true"
import script from "./assistantChatTester.vue?vue&type=script&lang=js"
export * from "./assistantChatTester.vue?vue&type=script&lang=js"
import style0 from "./assistantChatTester.vue?vue&type=style&index=0&id=900db25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900db25c",
  null
  
)

export default component.exports